import type { Config as AdapterConfig } from '@/workflow/_contract/config';
import type { Config, ModeConfig } from '@/workflow-builder/_contract/config';

function isRecord(value: unknown): value is Record<string, unknown> {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function isModeConfig(value: unknown): value is ModeConfig {
    if (!isRecord(value) || !isRecord(value.nonActiveDimming)) return false;
    if (value.writeLocalWorkflowTrace !== undefined && typeof value.writeLocalWorkflowTrace !== 'boolean') return false;
    const dimming = value.nonActiveDimming;
    const booleanMapKeys = ['enabledByConstellationKey', 'enabledByLayoutKind'];
    const numberMapKeys = ['opacityByConstellationKey', 'opacityByLayoutKind'];
    if (dimming.defaultOpacity !== undefined && typeof dimming.defaultOpacity !== 'number') return false;
    if (!booleanMapKeys.every((key) => dimming[key] === undefined
        || isRecord(dimming[key])
        && Object.values(dimming[key]).every((entry) => typeof entry === 'boolean'))) return false;
    if (!numberMapKeys.every((key) => dimming[key] === undefined
        || isRecord(dimming[key])
        && Object.values(dimming[key]).every((entry) => typeof entry === 'number'))) return false;
    const workflowStateEntries = value.workflowStateEntries;
    return workflowStateEntries === undefined
        || isRecord(workflowStateEntries)
        && (workflowStateEntries.operationPresentationMode === undefined
            || workflowStateEntries.operationPresentationMode === 'panels'
            || workflowStateEntries.operationPresentationMode === 'wheels');
}

function isConfig(config: AdapterConfig): config is Config {
    return config.adapterMode === 'builder' && isModeConfig(config.adapterModeConfig);
}

export function requireConfig(config: AdapterConfig): Config {
    if (!isConfig(config)) {
        throw new Error(`Expected Builder Workflow config, received '${config.adapterMode}'.`);
    }
    return config;
}
